import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, getCurrentInstance, ComponentInstance, computed } from 'vue';

// Helpers
import { formatWithLocale } from '@white-label-helper/date-utilities';
import { DATE_TIME_FORMATS } from '@white-label-helper/date-utilities';

// Types
import { SearchProducts } from '@white-label-types/parking-booking';

interface TravelInsuranceQuoteDetailsProps {
  product: SearchProducts;
  component?: string;
}
export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-quote-details',
  props: {
    product: { default: () => ({}) },
    component: null
  },
  setup(__props: any, { expose }) {

const props = __props as { product: SearchProducts, component?: string };

const { proxy } = getCurrentInstance() as ComponentInstance | null;

;



const travellersText = computed(() => {
  const numberOfTravellers = props.product.quoteDetails.travellers.length;
  return proxy.$tc('searchExtras.travelInsurance.productCard.nTravellers', numberOfTravellers);
});

function formatTripDate(dateString: string) {
  if (dateString) {
    const date = new Date(dateString);
    return formatWithLocale(date, DATE_TIME_FORMATS.weekday_day_month_year, proxy?.$i18n.locale || 'en');
  }
  return '';
}

expose({
  formatTripDate,
})

return { __sfc: true,proxy, props, travellersText, formatTripDate }
}

})